/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { IHistoryResponse, IAdminDeleteHistory } from '../../api/types';
import { GET_ADMIN_DELETE_HISTORY } from '../../actions';

export type AdminDeleteHistoryState = IHistoryResponse<IAdminDeleteHistory>;

const initialState: AdminDeleteHistoryState = {
  content: [],
  loading: false,
};

const generic = genericReducers<AdminDeleteHistoryState>();
const adminDeleteHistory: IReducers<AdminDeleteHistoryState> = {
  [GET_ADMIN_DELETE_HISTORY[REQUEST]]: generic.get.request,
  [GET_ADMIN_DELETE_HISTORY[SUCCESS]]: generic.get.success,
  [GET_ADMIN_DELETE_HISTORY[FAILURE]]: generic.get.failure,
};

export default connectReducers<AdminDeleteHistoryState>(initialState, adminDeleteHistory);
